/** @jsx jsx */
import { css, jsx } from "@emotion/core"
import React from "react"
import { Spacer } from "@cd2/components/build/es6"
import { H3, P, TextBlock } from "@cd2/text/build/es6"
import { FloatingBox } from "./Misc/FloatingBox"

export function FieldGroup({
  name,
  children,
  description,
  className,
  headerZIndex,
}: {
  name?: string
  children: React.ReactNode
  description?: React.ReactNode
  className?: string
  headerZIndex?: number
}) {
  return (
    <FloatingBox
      css={css`
        ${FloatingBox.vars.borderColor}: #eee;
        border-bottom-width: 1px;
      `}
      className={className}
    >
      {name && (
        <H3
          size="small"
          blockSpacing={0}
          css={
            headerZIndex
              ? css`
                  position: relative;
                  z-index: ${headerZIndex};
                `
              : undefined
          }
        >
          {name}
        </H3>
      )}
      {description && (
        <React.Fragment>
          <Spacer size={4} />
          <TextBlock size="small" color="#999">
            {typeof description === "string" ? <P>{description}</P> : description}
          </TextBlock>
        </React.Fragment>
      )}
      {(name || description) && <Spacer size={20} />}
      {children}
    </FloatingBox>
  )
}
